import React from 'react';
import PropTypes from 'prop-types';
import AccordionContent from './AccordionContent';
import AccordionLabel from './AccordionLabel';

class Accordion extends React.Component {
    constructor(props) {
        super(props);

        const {
            open,
        } = props;

        this.state = {
            open: open,
        };
    }

    handleClick = () => {
        this.setState((prevState) => {
            return {
                open: !prevState.open,
            };
        });
    }

    render() {
        const {
            accordionContentStyle,
            children,
            label,
        } = this.props;

        const {
            open,
        } = this.state;

        return (
            <div>
                <AccordionLabel
                    handleClick={ this.handleClick }
                    open={ open }
                >{ label }</AccordionLabel>

                <AccordionContent
                    open={ open }
                    style={ accordionContentStyle }
                >
                    { children }
                </AccordionContent>
            </div>
        );
    }
}

Accordion.defaultProps = {
    open: false,
};

Accordion.propTypes = {
    accordionContentStyle: PropTypes.object,
    children: PropTypes.node.isRequired,
    label: PropTypes.object.isRequired,
    open: PropTypes.bool,
};

export default Accordion;



// WEBPACK FOOTER //
// ./src/components/ui/accordion/Accordion.js